import { useGtm } from '@gtm-support/vue-gtm'
import { usePageContext } from 'vike-vue/usePageContext'

export function useGtmOnPageMounted(pageType: string) {
  const { urlPathname, urlOriginal } = usePageContext()
  const gtm = useGtm()

  if (!gtm) return

  const splittedPath = urlPathname.split('/')

  // Pas de déclaration du nom de l'event car la méthode trackView surcharge avec la valeur 'content-view'
  const reactiveHead = {
    partner: import.meta.env.PUBLIC_ENV__WEBSITE,
    page: urlOriginal,
    page_type: pageType,
    arbo: urlPathname,
    page_chapter1: splittedPath[2],
    page_chapter2: splittedPath[3],
  }

  gtm.trackView(pageType, urlPathname, reactiveHead)
}

export function useGtmOnMountedSimulator(
  pageType: string,
  projectType: string | null,
  subProjecType?: string | null,
  amount?: number | null,
) {
  const { urlPathname, urlOriginal } = usePageContext()
  const gtm = useGtm()

  if (!gtm) return

  // Pas de déclaration du nom de l'event car la méthode trackView surcharge avec la valeur 'content-view'
  gtm.trackView(pageType, urlPathname, {
    partner: import.meta.env.PUBLIC_ENV__WEBSITE,
    page: urlOriginal,
    page_type: pageType,
    arbo: urlPathname,
    step_number: '1',
    type_projet: projectType,
    type_projet_detail: subProjecType,
    montant_emprunt: amount,
    duree_emprunt: '',
    choix_option_simulateur: '',
    type_emprunteur_formulaire: '',
  })
}

export function useGtmSimulatorClick() {
  const { urlPathname } = usePageContext()
  const gtm = useGtm()

  return (buttonLabel: string) => {
    if (!gtm) return

    gtm.trackEvent({
      event: 'click.action',
      click: buttonLabel,
      click_chapter1: urlPathname,
      dlv_event_placement: 'body',
    })
  }
}

export function useGtmHeaderClick() {
  const gtm = useGtm()

  return (buttonLabel: string, buttonUrl: string) => {
    if (!gtm) return

    gtm.trackEvent({
      event: 'click.navigation',
      click: buttonLabel,
      click_chapter1: buttonUrl,
      dlv_event_placement: 'header',
    })
  }
}

export function useGtmSelectOffer() {
  const { urlPathname } = usePageContext()
  const gtm = useGtm()

  return (buttonLabel: string, selectedProposal: string) => {
    if (!gtm) return

    gtm.trackEvent({
      event: 'click.action',
      click: buttonLabel,
      click_chapter1: urlPathname,
      choix_option_simulateur: selectedProposal,
    })
  }
}

export function useGtmSimulatorChangeStep() {
  const gtm = useGtm()

  return (
    stepNumber: number,
    stepName: string,
    projectType?: string,
    subProjecType?: string,
    amount?: number | null,
    duration?: number | null,
  ) => {
    if (!gtm) return

    gtm.trackEvent({
      event: 'form-step',
      step_number: stepNumber,
      step_name: stepName,
      type_projet: projectType,
      type_projet_detail: subProjecType,
      montant_emprunt: amount,
      duree_emprunt: duration,
    })
  }
}

export function useGtmOnMyselfFormSubmit() {
  const { urlPathname, urlOriginal } = usePageContext()
  const gtm = useGtm()

  return (pageType: string, amount?: number | null, savings?: number | null) => {
    if (!gtm) return

    gtm.trackEvent({
      event: 'form.complete.myself.success',
      page: urlOriginal,
      page_type: pageType,
      arbo: urlPathname,
      montant_emprunt: amount,
      montant_salarial_bloque: savings,
    })
  }
}
